<template>
    <div class="tel-comp">
        <el-col :span="4" >
            <el-input v-model="tel1" @input="changeValue" @blur="trigger('blur')"  @change="trigger('change')"></el-input>
        </el-col>
        <el-col class="sp" :span="1">-</el-col>
        <el-col :span="4" >
            <el-input v-model="tel2" @input="changeValue" @blur="trigger('blur')"  @change="trigger('change')"></el-input>
        </el-col>
        <el-col class="sp" :span="1">-</el-col>
        <el-col :span="4" >
            <el-input v-model="tel3" @input="changeValue" @blur="trigger('blur')"  @change="trigger('change')"></el-input>
        </el-col>
    </div>
</template>
<script>

export default {
    props: {
        value: String
    },
    created() {
        
        //this.$set('value',this.value)
    },
    data() {
        return {
            tel1: '',
            tel2: '',
            tel3: ''
        }
    },
    methods: {
        changeValue() {
            this.$emit('input', `${this.tel1}-${this.tel2}-${this.tel3}`);
        },
        trigger( event ) {
            this.$emit( event );
        }
    },
    watch: {
        value(val) {
            
            let tels = val?.split('-')
            if(tels && tels.length > 0) {
                for(let i=0; i<tels.length; i++) {
                    this.$set(this,'tel'+(i+1), tels[i])  
                }
            } else {
                this.tel1 = val
            }
        }   
    },
}

</script>

<style>
.tel-comp .sp { text-align: center; }
</style>